/* eslint-disable react/no-unescaped-entities */
import { useNavigate } from "react-router-dom";
import { useApp } from "../contexts/AppContext";
import { speak } from "../lib/i18n";
import { ArrowLeft, Volume2, Brain, HeartPulse, Pill, Users, AlertTriangle } from "lucide-react";

const CARDS = [
  { Icon: Brain, color: "#2BA3A0", title: "Qu'est-ce qu'un AVC ?", text: "Une partie du cerveau n'a plus reçu assez de sang. Certaines zones ont été abîmées : c'est pour cela qu'un côté du corps ou la parole sont touchés." },
  { Icon: HeartPulse, color: "#D9534F", title: "Pourquoi la tension compte", text: "Une tension trop haute fragilise les vaisseaux du cerveau. La mesurer chaque jour et rester dans la cible protège contre une nouvelle attaque." },
  { Icon: Pill, color: "#D4AF5A", title: "Les médicaments, tous les jours", text: "Ils fluidifient le sang et protègent le cœur. Même quand on se sent bien, il faut continuer : c'est eux qui empêchent la récidive." },
  { Icon: Users, color: "#0A1426", title: "Le cerveau réapprend", text: "Grâce aux exercices répétés, d'autres zones du cerveau prennent le relais. Chaque séance compte, même courte. L'aidant est un allié précieux." },
  { Icon: AlertTriangle, color: "#D9534F", title: "Signes d'urgence", text: "Visage qui tombe, bras faible, parole difficile : chaque minute compte. Appelez immédiatement de l'aide ou utilisez le code USSD d'urgence." },
];

export default function AvcExplainedPage() {
  const navigate = useNavigate();
  const { lang } = useApp();
  return (
    <div className="bc-in pt-2 pb-6 flex flex-col gap-4" data-testid="avc-explained-page">
      <div className="flex items-center gap-3">
        <button data-testid="avc-back" onClick={() => navigate(-1)} className="w-11 h-11 grid place-items-center rounded-full bg-white border border-[#E4E0D5] text-[#0A1426]"><ArrowLeft size={20} /></button>
        <h1 className="font-[Fraunces] text-2xl font-bold text-[#0A1426]">L'AVC expliqué</h1>
      </div>
      {CARDS.map((c) => (
        <div key={c.title} className="bg-white rounded-3xl border border-[#E4E0D5] p-5">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-12 h-12 rounded-2xl grid place-items-center" style={{ backgroundColor: `${c.color}1f`, color: c.color }}><c.Icon size={24} /></span>
            <h2 className="font-[Fraunces] text-lg font-bold text-[#0A1426] flex-1">{c.title}</h2>
            <button data-testid={`avc-listen-${c.title.slice(0, 6)}`} onClick={() => speak(`${c.title}. ${c.text}`, lang)} className="w-10 h-10 grid place-items-center rounded-full bg-[#F5F3EE] text-[#0A1426]"><Volume2 size={18} /></button>
          </div>
          <p className="text-[15px] text-[#0A1426]/85 leading-snug">{c.text}</p>
        </div>
      ))}
    </div>
  );
}
